export default "__VITE_ASSET__CVyeInMY__"